import React from 'react';
import { Link } from 'react-router-dom';
import { ProgressLog } from '../../types/entities';
import { Sun, Moon, Clock, Sparkle, CaretRight, ClipboardText } from 'phosphor-react';
import { formatDate, formatDuration } from '../../utils/date';

interface LatestProgressLogProps {
  latestLog: ProgressLog | null;
}

export default function LatestProgressLog({ latestLog }: LatestProgressLogProps) {
  const isMorning = latestLog?.period === 'MORNING';

  return (
    <div className="px-5 py-4 bg-white dark:bg-gray-800 rounded-2xl shadow-soft dark:shadow-none dark:border dark:border-gray-700">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Sparkle className="w-4 h-4 text-blush-400" />
          <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">Último registro</p>
        </div>
        <Link
          to="/progress-history"
          className="flex items-center gap-0.5 text-xs text-blush-500 hover:text-blush-600 font-semibold transition-colors"
        >
          Ver histórico
          <CaretRight className="w-3.5 h-3.5" />
        </Link>
      </div>

      {latestLog ? (
        <>
          <div className="flex items-center gap-2 mb-2">
            {isMorning ? (
              <Sun className="w-4 h-4 text-amber-400" />
            ) : (
              <Moon className="w-4 h-4 text-lavender-400" />
            )}
            <p className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
              {isMorning ? 'Rotina Matinal' : 'Rotina Noturna'}
            </p>
            <span className="ml-auto text-xs text-nude-400 dark:text-gray-500">
              {formatDate(latestLog.logDate)}
            </span>
          </div>

          <div className="flex items-center gap-4">
            <div className="text-center">
              <p className="text-2xl font-bold text-blush-500">
                {latestLog.stepLogs?.length ?? 0}
              </p>
              <p className="text-[10px] text-nude-400 dark:text-gray-500">etapas</p>
            </div>

            {latestLog.totalDurationSeconds != null && (
              <div className="flex items-center gap-1 text-xs text-nude-400 dark:text-gray-500">
                <Clock className="w-3.5 h-3.5" />
                {formatDuration(latestLog.totalDurationSeconds)}
              </div>
            )}

            {latestLog.notes && (
              <p className="flex-1 text-xs text-gray-500 dark:text-gray-400 truncate ml-2">
                {latestLog.notes}
              </p>
            )}
          </div>
        </>
      ) : (
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-nude-50 dark:bg-gray-700/60">
            <ClipboardText className="w-5 h-5 text-nude-400 dark:text-gray-400" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">
              Nenhum registro ainda
            </p>
            <p className="text-xs text-nude-400 dark:text-gray-500 mt-0.5">
              Execute sua rotina para começar a acompanhar seu progresso.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
